import type { FaireProductEntity } from "../../entity_types/product";

export const p_phkbdbmx6x: FaireProductEntity = {
  token: "p_phkbdbmx6x",
  type: "product",
  name: "Navy Meadow Task Pad Notebook Journal",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/d19d83fb4140361f0fe038b50b49a975d936c671db848433f332020428972e11.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e3f9d7cbaa87b1a2e97ce8f66fe24fb245887fed85717ee6dc6e30d7eb7830c1.jpeg",
    "https://cdn.faire.com/fastly/c6b140098b5865bb20d154fc0060e219e09323e4ee2c0d839a67183324284ac7.jpeg",
    "https://cdn.faire.com/fastly/3f8c7d179e0b02c8bc4ecaf0e766f7205a50bd411e1ea990ce37e91be70a7f92.png",
  ],
  priceDollars: 11,
  description:
    "E. Frances Paper + Shorthand Press Task Pad\n\nThe Task Pad by Shorthand Press, the essential list notepad. With a letterpressed cover and beautiful interior pages, this lined rule notebook has checkboxes on each line allowing you to keep your lists all together.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:05.772Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
